import { MESSAGE_SHOW } from '../actions/types';


export default function (state = {}, action) {

    switch (action.type) {
        case MESSAGE_SHOW:
            return action.payload;
        default: return state;
    }
}